import { render, staticRenderFns } from "./CategoryInput.vue?vue&type=template&id=a9facca6&scoped=true"
import script from "./CategoryInput.vue?vue&type=script&lang=js"
export * from "./CategoryInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9facca6",
  null
  
)

export default component.exports